import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

export const fetchRole = createAsyncThunk(
  'role/fetchRole',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/auth/me');
      return {
        login_role: response.data.login_role,
        lab_role: response.data.lab_role,
        category: response.data.category ?? null,
      };
    } catch (err) {
      return rejectWithValue(null);
    }
  }
);

const roleSlice = createSlice({
  name: 'role',
  initialState: {
    currentRole: null, 
    labRole: null,
    category: null,
    isLoading: true,   
  },
  reducers: {
    clearRole: (state) => {
      state.currentRole = null;
      state.labRole = null;
      state.category = null;
    },
    setGuestMode: (state) => {
      state.isLoading = false;
      state.currentRole = null;
      state.labRole = null;
      state.category = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRole.pending, (state) => {
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.currentRole = action.payload.login_role;
        state.labRole = action.payload.lab_role;
        state.category = action.payload.category;
      })
      .addCase(fetchRole.rejected, (state) => {
        state.isLoading = false;
        state.currentRole = null;
        state.labRole = null;
        state.category = null;
      });
  },
});

export const { clearRole, setGuestMode } = roleSlice.actions;
export const selectCurrentRole = (state) => state.role.currentRole;
export const selectRoleLoading = (state) => state.role.isLoading;
export const selectLabRole = (state) => state.role.labRole;
export const selectPartnerCategory = (state) => state.role.category;

export default roleSlice.reducer;